import { ApiResponse } from "@/api/api.d";
import { api } from "@/api/api";
import { GetTransactionHistoryResponse } from "@/dto/transaction/transaction-response";
import { GetTransactionHistoryRequest } from "@/dto/transaction/transaction-request";
import {
  AccountDetailResponse,
  BranchesResponse,
  ConfirmSellReq,
  ExchangeRatesResponse,
  ExportTransHistoryReq,
  InitSellReq,
  SellFXResponse,
  TransHisDetailReq,
  TransHisDetailResponse,
  TransHistoryReq,
} from "@/dto/accounts/response/UserInfo";

const transactionAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionHistory: builder.query<
      ApiResponse<GetTransactionHistoryResponse>,
      GetTransactionHistoryRequest
    >({
      query: (data) => ({
        url: "/customer-service/rest/web/request",
        method: "POST",
        functionName: "getTransactionHistory",
        categoryCode: "CARD_AND_ACCOUNT",
        data,
      }),
    }),
    getAccountDetail: builder.query<
      ApiResponse<AccountDetailResponse>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: "/customer-service/rest/web/request",
        method: "POST",
        functionName: "getAccountDetail",
        data: {
          accountNo: id,
        },
      }),
    }),
    getExchangeRate: builder.query<ApiResponse<ExchangeRatesResponse>, void>({
      query: () => ({
        url: "/customer-service/rest/web/request",
        method: "POST",
        functionName: "getExchangeRate",
      }),
    }),
    getBranchByCondition: builder.query<ApiResponse<BranchesResponse>, void>({
      query: () => ({
        url: "/customer-service/rest/web/request",
        method: "POST",
        functionName: "getBranchByCondition",
      }),
    }),
    getAccountsToSellFx: builder.query<ApiResponse<SellFXResponse>, void>({
      query: () => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "getAccountsToSellFx",
      }),
    }),
    downloadSellFxTcFile: builder.mutation<ApiResponse<any>, void>({
      query: () => ({
        url: "/customer-service/rest/web/request",
        method: "POST",
        functionName: "downloadSellFxTcFile",
      }),
    }),
    initSellForeignExchange: builder.mutation<ApiResponse<any>, InitSellReq>({
      query: (data) => ({
        url: "/transfer-service/rest/app/request",
        method: "POST",
        functionName: "initSellForeignExchange",
        data,
      }),
    }),
    confirmSellForeignExchange: builder.mutation<
      ApiResponse<any>,
      ConfirmSellReq
    >({
      query: (data) => ({
        url: "/transfer-service/rest/app/request",
        method: "POST",
        functionName: "confirmSellForeignExchange",
        data,
      }),
    }),
    exportTransHistory: builder.mutation<
      ApiResponse<any>,
      ExportTransHistoryReq
    >({
      query: (data) => ({
        url: "/customer-service/rest/app/request",
        method: "POST",
        functionName: "exportAccountTransactionHistory",
        data,
      }),
    }),
    getTransHistory: builder.query<ApiResponse<any>, TransHistoryReq>({
      query: (data) => ({
        url: "/customer-service/rest/app/request",
        method: "POST",
        functionName: "getTransactionHistory",
        data,
      }),
    }),
    getTransactionHistoryDetail: builder.query<
      ApiResponse<TransHisDetailResponse>,
      TransHisDetailReq
    >({
      query: (data) => ({
        url: "/customer-service/rest/app/request",
        method: "POST",
        functionName: "getTransactionHistoryDetail",
        data,
      }),
    }),
  }),
});

export const {
  useLazyGetTransactionHistoryQuery,
  useLazyGetAccountDetailQuery,
  useGetExchangeRateQuery,
  useGetBranchByConditionQuery,
  useGetAccountsToSellFxQuery,
  useDownloadSellFxTcFileMutation,
  useInitSellForeignExchangeMutation,
  useConfirmSellForeignExchangeMutation,
  useExportTransHistoryMutation,
  useLazyGetTransHistoryQuery,
  useGetTransactionHistoryDetailQuery,
} = transactionAPI;
